import { SmoothScroll } from "@/components/SmoothScroll";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { Intro } from "@/components/Intro";
import { Services } from "@/components/Services";
import { About } from "@/components/About";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Landing() {
  return (
    <SmoothScroll>
      <Header />
      <main>
        <Hero />
        <EditorialMarquee />
        <Intro />
        <Services />
        <About />
        <Contact />
      </main>
      <Footer />
    </SmoothScroll>
  );
}
